module.exports = __webpack_public_path__ + "img/icon-water.a0fe120e.svg";